<template>
  <div class="app-container" v-if="form">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="tab-box">
        <span :class="{'active': tabType === 1}" @click="tabType = 1">基础信息</span>
        <span :class="{'active': tabType === 2}" @click="tabType = 2">物流信息</span>
        <span :class="{'active': tabType === 3}" @click="tabType = 3">订单详情</span>
      </div>
      <template v-if="tabType==1">
        <div class="title-box"><span class="txt1">基础信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="订单编码">{{form.orderNum}}</el-descriptions-item>
          <el-descriptions-item label="快递方式">{{form.deliveryOptions === 1?'中通快递':(form.deliveryOptions === 2?'顺丰快递':'')}}</el-descriptions-item>
          <el-descriptions-item label="订单状态">{{form.state === 0?'已取消':(form.state === 1?'待付款':(form.state === 2?'待发货':(form.state === 3?'待收货':(form.state === 4?'已完成':'已失效'))))}}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{form.createdTime}}</el-descriptions-item>
          <el-descriptions-item label="付款时间">{{form.payTime}}</el-descriptions-item>
          <el-descriptions-item label="关联售后订单" v-if="activeName === 2">{{form.customerAfterOrderNum}}</el-descriptions-item>
          <el-descriptions-item label="发货时间" v-if="activeName === 3"></el-descriptions-item>
          <el-descriptions-item label="完成时间" v-if="activeName === 4"></el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">申请人信息</span></div>
        <el-descriptions v-if="form.customerPO">
          <el-descriptions-item label="下单人">{{form.customerPO.name}}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{form.customerPO.pho}}</el-descriptions-item>
          <el-descriptions-item label="所属区域">{{form.addrProvince}}{{form.addrCity}}{{form.addrArea}}{{form.addrDetail}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">申请人从属关系</span></div>
        <el-descriptions :column="1">
          <el-descriptions-item label="技术线" v-if="form.technicianInfoLine && form.technicianInfoLine.length">
            <div class="fr1-body">
              <span class="blueColor">{{custTechLine}}</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="业务线">
            <div class="fr1-body">
              <span class="blueColor">{{custBusinessLine}}</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="城市公司">{{form.nameCity}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">支付信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="补差金额">{{form.repairMoney}}</el-descriptions-item>
          <el-descriptions-item label="支付方式">
            {{form.payType === 1?'微信':form.payType === 2?'支付宝':form.payType===3?'零售价':form.payType===30?'银行卡支付':''}}
            </el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-else-if="tabType === 2">
        <div class="title-box"><span class="txt1">收货信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="收货人姓名">{{form.name}}</el-descriptions-item>
          <el-descriptions-item label="收货人联系方式">{{form.phone}}</el-descriptions-item>
          <el-descriptions-item label="联系人地址">{{form.addrProvince}}{{form.addrCity}}{{form.addrArea}}{{form.addrDetail}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">物流信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="发货时间">{{form.sendTime}}</el-descriptions-item>
        </el-descriptions>
        <el-table :data="form.deliveryList" style="width: 100%">
          <el-table-column prop="deliveryName" label="包裹" align="center" key="1"></el-table-column>
          <el-table-column prop="deliveryNum" label="快递编号" align="center" key="2"> </el-table-column>
          <el-table-column label="操作" align="center" width="230" key="3">
            <template slot-scope="{ row }">
              <el-button type="text" @click="lookLogistics(row)">查看物流</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="title-box"><span class="txt1">发货信息</span></div>
        <el-table :data="goodsList" style="width: 100%" fit>
          <el-table-column prop="name" label="商品" align="center" key="4"></el-table-column>
          <!-- REQ-2026-234328：只保留这一列，旧「规格」列同维度已删；为空回落旧值 -->
          <el-table-column label="产品规格" align="center" key="5-1">
            <template slot-scope="{row}">
              {{row.productSpec || row.spec || '无规格值'}}
            </template>
          </el-table-column>
          <el-table-column prop="jushuitanCode" label="聚水潭规格编码" align="center" key="6"></el-table-column>
          <el-table-column prop="combineCount" label="下单数量（件）" align="center" key="7"></el-table-column>
          <el-table-column label="是否为预售" align="center" key="8">
            <template slot-scope="{ row }">
              {{row.presell?'是':'否'}}
            </template>
          </el-table-column>
          <el-table-column prop="presellTime" label="预售商品距离预计发货时间还剩（天）" align="center" key="9"> </el-table-column>
          <el-table-column prop="sendNum" label="已发数量（件）" align="center" key="10"> </el-table-column>
          <el-table-column prop="daiNum" label="待发数量（件）" align="center" key="11"> </el-table-column>
        </el-table>
      </template>
      <template v-else-if="tabType === 3">
        <div class="title-box"><span class="txt1">基础信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="收货人姓名">{{form.name}}</el-descriptions-item>
          <el-descriptions-item label="收货人联系方式">{{form.phone}}</el-descriptions-item>
          <el-descriptions-item label="联系人地址">{{form.addrProvince}}{{form.addrCity}}{{form.addrArea}}{{form.addrDetail}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions>
          <el-descriptions-item label="商品列表"></el-descriptions-item>
        </el-descriptions>
        <el-table :data="noSendList" style="width: 100%">
          <!-- <el-table-column label="序号" align="center" type="index" key="12">
            <template slot-scope="scope">
              {{ scope.$index+1 }}
            </template>
          </el-table-column> -->
          <el-table-column label="序号" type="index" width="50" key="12"></el-table-column>
          <el-table-column prop="name" label="商品名称" align="center" key="13"></el-table-column>
          <el-table-column label="产品规格" align="center" key="14-1">
            <template slot-scope="{row}">
              {{row.productSpec || row.spec || '无规格值'}}
            </template>
          </el-table-column>
          <el-table-column prop="jushuitanCode" label="聚水潭规格编码" align="center" key="15"></el-table-column>
          <el-table-column prop="skuRetailPrice" label="市场价" align="center" key="16"> </el-table-column>
          <el-table-column prop="combineCount" label="数量" align="center" key="17"> </el-table-column>
          <el-table-column prop="tableMoney" label="小计" align="center" key="18"> </el-table-column>
        </el-table>
      </template>
    </el-card>
    <logistics-details-vue ref="logisticsDetailsVue" />
  </div>
</template>
<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import { Subtr, accMul } from '@/utils/index'
import logisticsDetailsVue from '@/views/common/logisticsDetails.vue';
import { fromPairs } from 'lodash';
export default {
  props: ['rowItem'],
  components: { logisticsDetailsVue },
  data() {
    return {
      activeName: 2,
      tabType: 1,  //1基础信息 2 物流信息 3
      tableData: [],
      form: '',
      orderPayType: ['', '零售价支付', '余额账户支付', '积分账户支付', '赠送账户支付', '在线支付', '组合支付']
    };
  },
  created() {
    this.activeName = +this.rowItem.activeName
    this.getDetails()
    this.getLogisticsNumber(this.rowItem.customerOrderId)
  },
  computed: {
    custBusinessLine() {
      const arr = (this.form.customerLine || []).map(it => it.name + '【' + this.getCLevelLabel(it.clevel) + '】')
      return arr.join(' - ')
    },
    custTechLine() {
      const form = this.form
      const arr = (form.technicianInfoLine || []).map(it => it.realName + '【' + it.levelName + '】')
      const cust = (form.customerLine || [])[0]
      const custName = cust ? cust.name : (form.name || '')
      const custLevel = cust ? cust.clevel : null
      const self = custName + '【' + this.getCLevelLabel(custLevel) + '】'
      return arr.length ? self + ' - ' + arr.join(' - ') : self
    },
  },
  methods: {
    getCLevelLabel(cLevel, customerType) {
      const map = { 1: '总监', 2: '营销经理', 3: '大区经理', 4: '地区经理', 5: '县区经理', 6: '研修班', 7: '体验班', 8: '普通人员' }
      if (cLevel && map[cLevel]) return map[cLevel]
      const tMap = { 1: '总监经理', 2: '业务员', 3: '加盟商' }
      return tMap[customerType] || ''
    },
    getDetails() {
      goodsOrderApi.getExchangeDetail({ id: this.rowItem.customerOrderId }).then(({ data }) => {
        if (data.customerOrderGoodsList && data.customerOrderGoodsList.length) {
          data.customerOrderGoodsList.forEach(it => {
            it.tableMoney = accMul(it.combineCount, it.skuRetailPrice)  //小计
          })
        }
        this.form = data;
      })
    },
    getLogisticsNumber(id) {
      goodsOrderApi.getGoodsList({ orderId: id , pageSize: 1000 }).then(res => {
        let { list } = res.data, sendList = [], noSendList = [];
        if (list.length > 0) {
          list.forEach(it => {
            it.daiNum = Subtr(it.combineCount, it.sendNum);
            let price = it.skuRetailPrice || it.goodsPrice
            it.tableMoney = accMul(price, it.combineCount);
            if (it.isSend) {
              sendList.push(it);
            } else {
              noSendList.push(it);
            }
          })
        }
        this.goodsList = list;
        this.sendList = sendList;
        this.noSendList = noSendList;
      })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    lookLogistics(row) {
      let { phone } = this.form;
      let str = phone ? `:${phone.trim().slice(-4)}` : ''
      this.$refs.logisticsDetailsVue.handleShow(row.deliveryNum + str)
    },
  },
};
</script>
<style lang="scss" scoped>
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.title-cont {
  padding: 10px 20px;
  .fr3 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .fr3-body {
      width: 33.33%;
      font-size: 14px;
      color: #2e2f3e;
      line-height: 30px;
    }
  }
  .fr1 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .fr1-body {
      width: 100%;
      font-size: 14px;
      color: #2e2f3e;
      line-height: 30px;
    }
  }
}
</style>
